/**
 * @file components/chat/DaySeparator.tsx
 * 7.3-03 — Puce de date centrée ("Aujourd'hui" / "Hier" / "12 juin"), façon
 * messagerie. Sticky en haut du fil pendant le scroll.
 */
import React from 'react';

function startOfDay(ts: number): number {
  const d = new Date(ts);
  d.setHours(0, 0, 0, 0);
  return d.getTime();
}

const DAY_MS = 24 * 60 * 60 * 1000;

/** Libellé fr-FR : Aujourd'hui / Hier / "12 juin" (+ année si différente). */
export function formatDayLabel(at: number, now: number = Date.now()): string {
  const day = startOfDay(at);
  const today = startOfDay(now);
  if (day === today) return "Aujourd'hui";
  if (day === today - DAY_MS) return 'Hier';
  const d = new Date(at);
  const sameYear = d.getFullYear() === new Date(now).getFullYear();
  return d.toLocaleDateString('fr-FR', {
    day: 'numeric',
    month: 'long',
    ...(sameYear ? {} : { year: 'numeric' }),
  });
}

export default function DaySeparator({ at }: { at: number }): React.ReactElement {
  return (
    <div className="sticky top-1 z-[5] flex justify-center py-1">
      <span className="rounded-full border border-border bg-muted px-3 py-1 text-[11px] font-medium text-muted-foreground shadow-sm">
        {formatDayLabel(at)}
      </span>
    </div>
  );
}
